import request from '@/utils/request'

export function login(username, password,key,code) {
  return request({
    url: '/api/admin/login',
    method: 'post',
    data: {
      username,
      password,
      key,
      code
    }
  })
}

export function getInfo() {
  return request({
    url: '/api/admin/info',
    method: 'get',
  })
}

export function logout(params) {
  return request({
    url: '/api/admin/logout',
    method: 'post',
    data: params
  })
}

export function fetchList(params) {
  return request({
    url: '/api/admin/list',
    method: 'post',
    data: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/api/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/api/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/api/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/api/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/api/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/api/admin/role/update',
    method: 'post',
    data: data
  })
}
//日志分页查询
export function listPage(data) {
  return request({
    url:'/api/log/listPage',
    method:'post',
    data
  })
}
//日志--操作类型
export function selectType(data) {
  return request({
    url:'/api/log/selectType',
    method:'post',
    data
  })
}

//用户反馈--列表
export function feedbackPage(data) {
  return request({
    url:'/api/feedback/page',
    method:'post',
    data
  })
}
//用户反馈--列表查看
export function feedbackSearch(id) {
  return request({
    url:'/api/feedback/'+id,
    method:'get',
  })
}
//用户反馈--列表查看
export function sendEmail(id) {
  return request({
    url:'/api/feedback/send/email/'+id,
    method:'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js